import { Routes } from '@angular/router';

import { AuthService } from '../../auth/auth.service';

import { GpMainComponent } from './gp-main.component';

export const GamePlanRoutes: Routes = [
    {
        path: 'game-plan',
        component: GpMainComponent,
        canActivate: [AuthService],
    },
];
